// https://github.com/sindresorhus/is-absolute-url
export function isAbsoluteUrl(url: string): boolean {
  if (typeof url !== 'string') {
    throw new TypeError('Expected a string');
  }

  return /^[a-z][a-z0-9+.-]*:/.test(url);
}
